<template>
  <div class="timeline-media-box-search">
    <div class="title-container wt2-text-2xl wt2-color-normal">
      <span v-text="emptyLightboxTitle" />
    </div>
    <div class="go-to-container">
      <div class="-button-box">
        <div class="-button-round -fixed-colors" @click="gotoAssetSearch">
          <i class="wticon wticon-magnifier" />
        </div>
        <span class="wt2-color-normal wt2-text-n">{{
          'emptyLightBox.media' | culture
        }}</span>
      </div>
      <div class="-button-box">
        <div class="-button-round" @click="gotoWallpaper()">
          <i class="wticon wticon-Bucket" />
        </div>
        <span class="wt2-color-normal wt2-text-n">{{
          'wallpaper.addTitle' | culture
        }}</span>
      </div>
      <div v-if="showUploadButton" class="-button-box">
        <div class="-button-round" @click="$emit('open-media-upload-view')">
          <i class="wticon wticon-upload2" />
        </div>
        <span class="wt2-color-normal wt2-text-n">{{
          'emptyLightBox.upload' | culture
        }}</span>
      </div>
      <div v-if="showRecordAudioButton" class="-button-box">
        <div class="-button-round" @click="$emit('open-audio-upload-view')">
          <i class="wticon wticon-mic" />
        </div>
        <span class="wt2-color-normal wt2-text-n">{{
          'uploadView.cta.recordAudio' | culture
        }}</span>
      </div>
      <div class="-button-box">
        <div class="-button-round" @click="gotoFaceOnCamera()">
          <i class="wticon wticon-camera" style="font-size: 14px" />
        </div>
        <span class="wt2-color-normal wt2-text-n">{{
          'uploadView.cta.recordVideo' | culture
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';
import { mapGetters } from 'vuex';

export default {
  inject: [
    'gotoAssetSearch',
    'gotoWallpaper',
    'shouldAbortKeyBoard',
    'gotoFaceOnCamera',
  ],

  data() {
    const storyStartPoint = app.storyController.story.get('storyStartPoint');
    return {
      emptyLightboxTitle:
        storyStartPoint === app.storyStartPoint.STORYBOARD
          ? app.culture.get('emptyLightBox.titleWhenFromStoryboard')
          : app.culture.get('emptyLightBox.title'),
      showUploadButton: !app.isEmbedded,
    };
  },

  computed: {
    ...mapGetters('user', ['isImpededTemplatizer']),

    showRecordAudioButton() {
      return !this.isImpededTemplatizer;
    },
  },

  beforeDestroy: function () {
    app.keyboardAccessibility.remove(app.KEYBOARD_LAYER.SEARCH_MEDIA);
  },

  mounted: function () {
    const handlers = [
      {
        on: 'keydown',
        key: 13 /* ENTER */,
        run: (e) => {
          if (
            _.isFunction(this.shouldAbortKeyBoard) &&
            this.shouldAbortKeyBoard(e)
          ) {
            return;
          }

          this.gotoAssetSearch(e);
        },
      },
    ];

    app.keyboardAccessibility.add(app.KEYBOARD_LAYER.SEARCH_MEDIA, handlers);
  },
};
</script>

<style lang="scss">
.timeline-media-box-search {
  width: 561px;
  height: 100%;
  margin: 0 auto;
  z-index: 10;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title-container {
    align-self: center;
    margin-top: 60px;
  }

  .go-to-container {
    display: flex;
    justify-content: space-around;
    margin-top: 30px;

    .-button-box {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 20px;
      width: 111px;

      > span {
        margin-top: 7px;
        text-align: center;
      }
    }
  }
}
</style>
